<div [formGroup]="campaignForm" class="has-validation">
  <label class="form-label">
    {{ 'field.phone' | translate }}
  </label>
  <input type="text" class="form-control" id="phone" formControlName="phone"  [ngClass]="{ 'is-invalid': campaignForm.get('phone')?.invalid}" />
  <div class="invalid-feedback" translate="field.required"></div>
</div>
